import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LeafConfig, LeafConfigServiceToken, LeafSessionService, selectCurrentAccountData } from '@input-output-labs/ngleaf';

@Component({
  standalone: false,
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent {
  @Input() overlay = false;
  @Output() menuClosed = new EventEmitter<void>();

  collapsed = false;
  isAdmin$: Observable<boolean>;

  get iconsOnly(): boolean {
    return this.collapsed && !this.overlay;
  }

  constructor(
    public sessionService: LeafSessionService,
    private router: Router,
    private store: Store,
    @Inject(LeafConfigServiceToken) public config: LeafConfig
  ) {
    this.isAdmin$ = this.store.select(selectCurrentAccountData).pipe(
      map(account => account?.admin === true)
    );
  }

  logout() {
    this.sessionService.logout();
  }

  toggleCollapse() {
    this.collapsed = !this.collapsed;
  }

  onLinkClick(event: MouseEvent): void {
    if (!this.overlay) {
      return;
    }
    const target = event.target as HTMLElement | null;
    if (target?.closest('a')) {
      this.menuClosed.emit();
    }
  }

  requestClose(): void {
    this.menuClosed.emit();
  }
}
